import axios from 'axios';
import { Dropdown } from 'primereact/dropdown';
import { useEffect, useState } from 'react'
import { useAppSelector } from '../../store/hooks';
import RaporCard from './RaporCard';
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { Button } from "primereact/button";

export default function OSBRapor() {
  const pdf = new jsPDF('landscape', undefined, 'A4');
  const osbler = useAppSelector(state => state.sharedState.osbler);
  const copyOsbler = JSON.parse(JSON.stringify(osbler));
  copyOsbler.unshift({
    adi: `Tüm OSB'ler`,
    id: 0
  });

  const token = useAppSelector(state => state.authState.token);
  const [osbID, setOSBID] = useState(0);
  const [reportData, setReportData] = useState<any>(undefined);
  const pdfPage = document.getElementById("tab4") as HTMLElement;

  const downloadPdf = () => {
    let page: any
    page = pdfPage

    html2canvas(page).then((canvas: any) => {
      pdf.addImage(canvas, "PNG", 10, 10, 270, 150);
      pdf.save("OSB Raporu.pdf");
    });
  };
  var areaFormatter: any = new Intl.NumberFormat();

  useEffect(() => {
    getData();
  }, [osbID])

  const getData = async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/bolge/${osbID}?token=${token}`)

    const reportData = response.data;

    setReportData(reportData);

    setTimeout(() => {

      const barWithoutAxis3 = new (window as any).Highcharts.Chart('il_bar', {
        colors: ['#b68a33', '#60471c'],
        chart: {
          type: 'bar',
          backgroundColor: '#1f2d40',
        },
        xAxis: {
          categories: reportData.parselData.map((parselObject: any) => parselObject.range),
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br>',
          pointFormat: `{point.y}`
        },
        title: {
          text: `Boş Parsel Büyüklükleri`,
          style: { "color": "#ffffff", "fontSize": "14px" },
          align: 'center'
        }, legend: {
          enabled: false
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          data: reportData.parselData.map((parselObject: any) => Number(parselObject.count)),
          colorByPoint: true,
        }],
        exporting: {
          enabled: false
        }
      });


      if (reportData.parselAsamaData.length > 0) {
        const pie1 = new (window as any).Highcharts.Chart('il_parsel_bar', {
          colors: ['#008184', '#005455', '#b68a33', '#60471c'],
          chart: {
            type: 'pie',
            backgroundColor: '#1f2d40',
            options3d: {
              enabled: true,
              alpha: 45
            }
          },
          exporting: {
            enabled: false
          },
          title: {
            text: 'Toplam Parsel Bilgisi',
            style: { "color": "#ffffff", "fontSize": "14px" },
            align: 'left'
          },
          legend: {
            enable: true,
            layout: 'vertical',
            align: 'right',
            verticalAlign: 'middle',
            itemStyle: { "color": "#ffffff", "fontSize": "10px" }
          },
          tooltip: {
            pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
          },
          plotOptions: {
            pie: {
              innerSize: '50%',
              depth: 20,
              dataLabels: {
                enabled: false
              },
              showInLegend: true,
            }
          },
          series: [{
            name: 'Brands',
            data: [[
              'İnşaat Halinde Parsel Sayısı',
              Number(reportData.parselAsamaData[0].total),
            ], [
              'Proje Halindeki Parsel Sayısı',
              Number(reportData.parselAsamaData[1].total),
            ], [
              'Üretime Geçen Parsel Sayısı',
              Number(reportData.parselAsamaData[2].total)
            ],]
          }]
        });
      }

      // const totalParsel = Number(reportData.parselNitelikData[0].count);
      // const tahsisParsel = Number(reportData.parselNitelikData[1].count);
      const totalParsel = parseFloat(Number(reportData.parselNitelikData[0].count)?.toLocaleString());
      const tahsisParsel = parseFloat(Number(reportData.parselNitelikData[1].count)?.toLocaleString());
      const sanayiParsel = Number(reportData.parselNitelikData[2].count);

      if (!reportData.parselAreaData[0].area) {
        reportData.parselAreaData[0].area = 0;
      }
      if (!reportData.parselAreaData[1].area) {
        reportData.parselAreaData[1].area = 0;
      }

      // const totalParselArea = Number(reportData.parselAreaData[1].area.toFixed(2));
      // const tahsisParselArea = Number(reportData.parselAreaData[0].area.toFixed(2));
      const totalParselArea = parseFloat(Number(reportData.parselAreaData[1].area)?.toLocaleString());
      const tahsisParselArea = parseFloat(Number(reportData.parselAreaData[0].area)?.toLocaleString());

      let uretimParsel;
      if (reportData.parselAsamaData.length > 0) {
        uretimParsel = Number(reportData.parselAsamaData[2].total);
      } else {
        uretimParsel = 0;
      }

      const tahsisPercentage = parseFloat((Number((tahsisParsel / totalParsel).toFixed(2)) * 100)?.toLocaleString());
      // const uretimPercentage = Number((uretimParsel / totalParsel).toFixed(4)) * 100;
      const uretimPercentage = parseFloat((Number((uretimParsel / totalParsel).toFixed(2)) * 100)?.toLocaleString());

      // const emptyParcelCount = totalParsel - tahsisParsel;
      const emptyParcelCount = parseFloat((totalParsel - tahsisParsel).toFixed(2));

      // const emptyParcelArea = Number((totalParselArea - tahsisParselArea).toFixed(2));
      const emptyParcelArea = parseFloat(Number(totalParselArea - tahsisParselArea)?.toLocaleString());

      const barWithoutAxis = new (window as any).Highcharts.Chart('il_doluluk', {
        colors: ['#b68a33', '#60471c'],
        chart: {
          type: 'column',
          backgroundColor: '#1f2d40',
          options3d: {
            enabled: true,
            alpha: 0,
            beta: 5,
            depth: 30,
            viewDistance: 5
          },
          marginLeft: 3
        },
        xAxis: {
          gridLineWidth: 0,
          categories: ['Sanayi Parseli Doluluk Oranı', 'Sanayi Parseli Üretim Doluluk Oranı'],
          labels: {
            enabled: true,
            style: { "color": "#ffffff", "fontSize": "10px" }
          },
          title: {
            enabled: false
          }
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br>',
          pointFormat: '%{point.y}'
        },
        title: {
          text: `Parsel Doluluk Oranı`,
          style: { "color": "#ffffff", "fontSize": "14px" },
          align: 'center'
        }, legend: {
          enabled: false
        },
        plotOptions: {
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          pointWidth: 110,
          data: [tahsisPercentage, uretimPercentage],
          colorByPoint: true,
        }],
        exporting: {
          enabled: false
        }
      });

      new (window as any).Highcharts.Chart('parsel_alan', {
        colors: ['#b68a33', '#60471c'],
        chart: {
          type: 'column',
          backgroundColor: '#1f2d40',
          options3d: {
            enabled: true,
            alpha: 0,
            beta: 5,
            depth: 30,
            viewDistance: 5
          },
          marginLeft: 3
        },
        xAxis: {
          gridLineWidth: 0,
          categories: ['Toplam Tahsis Yapılan Parsel Alanı (ha)', 'Toplam Boş Parsel Alanı (ha)'],
          labels: {
            enabled: true,
            style: { "color": "#ffffff", "fontSize": "10px" }
          },
          title: {
            enabled: false
          }
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br>',
          pointFormat: '{point.y}'
        },
        title: {
          text: `Toplam Parsel Alanı`,
          style: { "color": "#ffffff", "fontSize": "14px" },
          align: 'center'
        }, legend: {
          enabled: false
        },
        plotOptions: {
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          pointWidth: 110,
          data: [tahsisParselArea, emptyParcelArea],
          colorByPoint: true,
        }],
        exporting: {
          enabled: false
        }
      });

      new (window as any).Highcharts.Chart('parsel_sayi', {
        colors: ['#b68a33', '#60471c'],
        chart: {
          type: 'column',
          backgroundColor: '#1f2d40',
          options3d: {
            enabled: true,
            alpha: 0,
            beta: 5,
            depth: 30,
            viewDistance: 5
          },
          marginLeft: 3
        },
        xAxis: {
          gridLineWidth: 0,
          categories: ['Toplam Tahsis Yapılan Parsel Sayısı', 'Toplam Boş Parsel Sayısı'],
          labels: {
            enabled: true,
            style: { "color": "#ffffff", "fontSize": "10px" }
          },
          title: {
            enabled: false
          }
        },
        yAxis: {
          gridLineWidth: 0,
          labels: {
            enabled: false
          },
          title: {
            enabled: false
          }
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br>',
          pointFormat: '{point.y}'
        },
        title: {
          text: `Toplam Parsel Sayısı`,
          style: { "color": "#ffffff", "fontSize": "14px" },
          align: 'center'
        }, legend: {
          enabled: false
        },
        plotOptions: {
          column: {
            depth: 25,
            stacking: 'normal',
            dataLabels: {
              enabled: true
            }
          }
        },
        series: [{
          pointWidth: 110,
          data: [totalParsel, emptyParcelCount],
          colorByPoint: true,
        }],
        exporting: {
          enabled: false
        }
      });
    })
  }

  return (
    <>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'space-between', alignItems: 'start' }}>
        <div className='rapor-column'>
          <Dropdown filter={true} options={copyOsbler} value={osbID} optionLabel='adi' optionValue='id' placeholder='İl Seçiniz' style={{ width: '800px' }} onChange={(e) => setOSBID(e.value)}>
          </Dropdown>
        </div>
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}><Button className="pdf-button" label='PDF Dışa Aktar' onClick={downloadPdf} /></div>
      </div>
      <div className="rapor-column-container" id='tab4'>
        <div style={{ display: 'flex', flexDirection: 'row', flex: 1 }}>
          <div className='rapor-row' style={{ padding: '10px' }}>
            <div id='il_bar' className='rapor-column-element' style={{ width: '100%', height: '100%' }}>
            </div>
          </div>
          <div className='rapor-row' style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
            <div className='rapor-column' style={{ width: '100%', height: '50%' }}>
              {reportData && reportData.bolgeData.length === 1 &&
                <div id='test' style={{ width: '30%', height: '100%', marginRight: '8px', display: 'flex', justifyContent: 'center', flexDirection: 'column' }}>
                  <div style={{ width: '90%', height: '30%' }}>
                    <RaporCard header="IBBSD-2 Bölge Adı" value={reportData.bolgeData.length === 1 ? reportData.bolgeData[0].i_adi : '-'}></RaporCard>
                  </div>
                  <div style={{ width: '90%', height: '30%' }}>
                    <RaporCard header="Teşvik Bölge Kodu" value={reportData.bolgeData.length === 1 ? reportData.bolgeData[0].t_adi : '-'}></RaporCard>
                  </div>
                  <div style={{ width: '90%', height: '30%' }}>
                    <RaporCard header="Coğrafi Bölge Adı" value={reportData.bolgeData.length === 1 ? reportData.bolgeData[0].c_adi : '-'}></RaporCard>
                  </div>
                </div>}
              <div id='il_parsel_bar' className='rapor-column-element' style={{ width: '100%', height: '100%', marginRight: '8px' }}>
              </div>
              <div id='il_doluluk' className='rapor-column-element' style={{ width: '40%', height: '100%' }}>
              </div>
            </div>
            <div className='rapor-column' style={{ width: '100%', height: '50%' }}>
              <div id='parsel_alan' className='rapor-column-element' style={{ width: '29%', height: '100%' }}>
              </div>
              <div id='parsel_sayi' className='rapor-column-element' style={{ width: '29%', height: '100%' }}>
              </div>
              <div id='card' className='rapor-column-element' style={{ width: '39%', height: '42vh', display: 'flex', flexDirection: 'column' }}>
                {reportData &&
                  <>
                    <div style={{ width: '100%', height: '50%', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                      <div style={{ width: '46%', height: '70%' }}>
                        <RaporCard header="Bölge Büyüklüğü (ha)" value={(reportData.osbData[0].count.toFixed(2))}></RaporCard>
                      </div>
                      <div style={{ width: '46%', height: '70%' }}>
                        <RaporCard header="Sanayi Parsel Planlanan Alan (ha)" value={reportData.osbData[2].count ? areaFormatter.format(reportData.osbData[2].count.toFixed(2)) : 0}></RaporCard>
                      </div>
                    </div>
                    <div style={{ width: '100%', height: '50%', display: 'flex', justifyContent: 'space-around', alignItems: 'center' }}>
                      <div style={{ width: '46%', height: '70%' }}>
                        <RaporCard header="İşyeri Açma ve Çalışma Ruhsatı Alan Sayısı" value={(reportData.osbData[3].count)?.toLocaleString()}></RaporCard>
                      </div>
                      <div style={{ width: '46%', height: '70%' }}>
                        <RaporCard header="İstihdam Sayısı" value={reportData.osbData[1].count?.toLocaleString()}></RaporCard>
                      </div>
                    </div>
                  </>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
